import { render, staticRenderFns } from "./dragAndDrop.vue?vue&type=template&id=3598cddf"
import script from "./dragAndDrop.vue?vue&type=script&lang=js"
export * from "./dragAndDrop.vue?vue&type=script&lang=js"
import style0 from "./dragAndDrop.vue?vue&type=style&index=0&id=3598cddf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports